export default __webpack_public_path__ + "static/portfolio-grid-rows-cf6d1cf4339f743dfbfcb11739b27e88.jpg";